module.exports = __webpack_public_path__ + "491f136a.png";